import logo from "../assets/logo.svg";
import avodaLogo from "../assets/avoda.svg";
import enokLogo from "../assets/enok.svg";
import heritageLogo from "../assets/heritage.png";
import "./index.css";

export function App() {
  return (
    <div className="app">
      <div className="app-content">
        <div className="logo-container">
          <img src={logo} className="logo" alt="logo" />
        </div>

        <h1>
          A management consulting and venture development firm dedicated to
          building and scaling startups through affiliate partnerships and
          strategic investments.
        </h1>
        <div className="portfolio">
          <p>Select Portfolio</p>
          <div className="portfolio-container">
            <a href="https://avoda.co">
              <div className="portfolio-item">
                <img src={avodaLogo} alt="logo" />
              </div>
            </a>
            <a href="https://enok.co">
              <div className="portfolio-item">
                <img src={enokLogo} alt="logo" />
              </div>
            </a>
            <a href="https://www.heritageland.us/">
              <div className="portfolio-item">
                <img src={heritageLogo} alt="logo" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
